import { Component, ViewChild } from '@angular/core';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { NgbCollapse, NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ComboService } from '../../../Model/Combo/combo.service';
import { CommonService } from '../../../Model/Common/common.service';
import { LetterDocumentService } from '../../../Model/LetterDocument/letter-document.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterOutlet, RouterModule, Router } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { SessionService } from '../../../Util/Session/session.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';

@Component({
  selector: 'app-letter-generate',
  standalone: true,
  imports: [FormsModule, CommonModule, LoaderComponent, RouterOutlet, RouterModule, DataTablesModule, NgbDatepickerModule, NgSelectModule,NgbCollapse],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './letter-generate.component.html',
  styleUrl: './letter-generate.component.scss'
})
export class LetterGenerateComponent {
  isDisabled: boolean = false;
  isCollapsed = false;
  Branchs = [];
  Clients = [];
  Sites = [];
  user = [] as any;
  Filter = {
    SelectType: 1,
    ESS_LetterTemplateGenerationRequestId: 0,
    EmpMasterId: null,
    ApprovalStatus: 'ALL',
    FromDate: null as any,
    FromDateObj: null as any,
    ToDate: null as any,
    ToDateObj: null as any,
    BranchId: null,
    ClientId: null,
    SiteId: null,
    EmpType: 'Front'
  }

  TableDatas: any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private session: SessionService,
    private dateFormat: CustomDateParserFormatter,
    protected common: CommonService,
    private toast: ToastService,
    private combo: ComboService,
    private utility: UtilityService,
    private letterDocument: LetterDocumentService,
    private download: DownloadSampleService
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('Branch');
    this.SelectDate('RegistrationDate', null, null);
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  FilterValidate(form: any) {
    if (form.valid) {
      this.isCollapsed = true;
      this.ESS_LetterTemplateGenerationRequestSelect();
    }
    else {
      form.submitted = true;
    }
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.Filter.FromDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.Filter.FromDateObj.day = 1;
          this.Filter.ToDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.Filter.ToDateObj.day = new Date(this.Filter.ToDateObj.year, this.Filter.ToDateObj.month, 0).getDate();
        }
        this.isDisabled = false;
      },
      complete: () => {},
      error: (error) => {
        this.isDisabled = false;
        this.toast.show({ message: error, type: toastTypeEnum.danger });
        return false;
      },
    });
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    if (Combotype == 'Site') {
      this.Filter.SiteId = null;
      this.Sites = [];
    } else if (Combotype == 'Client') {
      this.Filter.ClientId = null;
      this.Filter.SiteId = null;
      this.Clients = [];
      this.Sites = [];
    }
    this.combo.ComboLoad({
      'Combotype': Combotype, 'BranchId': this.Filter.BranchId, 'ClientId': this.Filter.ClientId, 'SiteId': this.Filter.SiteId, 'DesignationId': null, 'EmpType': null, 'EmpMasterID': this.user.UserId
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad) {
          if (Combotype == 'Branch') {
            this.Branchs = response.ComboLoad;
          } else if (Combotype == 'Client') {
            this.Clients = response.ComboLoad;
          } else if (Combotype == 'Site') {
            this.Sites = response.ComboLoad;
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  
  ESS_LetterTemplateGenerationRequestSelect() {
    this.isDisabled = true;
    this.Filter.FromDate = this.dateFormat.format(this.Filter.FromDateObj);
    this.Filter.ToDate = this.dateFormat.format(this.Filter.ToDateObj);
    this.letterDocument.ESS_LetterTemplateGenerationRequestSelect(this.Filter).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TableDatas = Object.values(response.Table);
        } else {
          this.TableDatas = Object.values([]);
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Link(Text: string) {
    return this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'LetterTemplate' + '/' + Text;
  }

  excelDownload(){
    // this.common.ExcelDump('Letter Generate Report', this.TableDatas);
    this.download.exportToExcelWithProgress(this.TableDatas,'Letter Generate Report');
  }

  clear() {
    this.TableDatas = [];
    try {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    }catch(e){}
  }
}
